var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-pdf-app',{attrs:{"pdf":_vm.pdfURL}})
}
var staticRenderFns = []

export { render, staticRenderFns }